var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#230CC2",
    d: "M18.964 29.571c7.989 0 12.57-.72 12.57-1.607s-4.581-1.607-12.57-1.607c-7.988 0-14.464.72-14.464 1.607 0 .888 6.476 1.607 14.464 1.607z",
    opacity: 0.115
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DCD9F5",
    d: "M30.97 15.133V10.13c0-2.237-1.567-3.06-3.036-3.06H9.327c-1.469 0-3.036.79-3.036 3.06V15.133c-1.469.164-2.872 1.151-2.872 3.422v3.882c0 .658.522 1.185 1.175 1.185h.392v3.06c0 .658.522 1.184 1.175 1.184h1.11c.652 0 1.175-.526 1.175-1.184v-3.093h20.467v3.093c0 .658.523 1.184 1.175 1.184h1.11c.653 0 1.175-.526 1.175-1.184v-3.093h.392c.653 0 1.175-.526 1.175-1.185v-3.85c-.098-2.27-1.501-3.257-2.97-3.421z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#230CC2",
    d: "M9 12.214h7.714v3.857H9zM19.929 12.214h7.714v3.857h-7.714z",
    opacity: 0.681
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2B2C32",
    fillRule: "nonzero",
    d: "M30.327 15.776V10.774c0-2.237-1.567-3.06-3.036-3.06H8.684c-1.469 0-3.036.79-3.036 3.06V15.776c-1.469.164-2.872 1.151-2.872 3.422v3.882c0 .658.522 1.185 1.175 1.185h.392v3.06c0 .658.522 1.184 1.175 1.184h1.11c.653 0 1.175-.526 1.175-1.184v-3.093H28.27v3.093c0 .658.523 1.184 1.176 1.184h1.11c.652 0 1.175-.526 1.175-1.184v-3.093h.391c.653 0 1.175-.527 1.175-1.185v-3.85c-.097-2.27-1.501-3.257-2.97-3.421zM6.758 10.774h.066c0-1.546 1.012-1.875 1.86-1.875h18.607c.849 0 1.86.329 1.86 1.875v4.969h-.88v-2.83c0-.658-.523-1.184-1.176-1.184h-7.181c-.653 0-1.176.526-1.176 1.184v2.83h-1.37v-2.83c0-.658-.523-1.184-1.176-1.184H9.011c-.653 0-1.175.526-1.175 1.184v2.83H6.758v-4.969zm20.337 2.139v2.83h-7.181v-2.83h7.181zm-10.837 0v2.83H9.076v-2.83h7.182zM6.595 27.325h-1.11v-3.093h1.11v3.093zm23.895 0h-1.11v-3.093h1.11v3.093zm1.534-4.245H3.918v-1.744h28.106v1.744zm0-2.928H3.918v-.954c0-1.975 1.437-2.27 2.253-2.27h23.601c.849 0 2.252.295 2.252 2.27v.954z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.3af4c9fb8205d3ef448d77e46c2b5f3c.svg";
export { ForwardRef as ReactComponent };